import React, { useEffect, useState } from "react";
import { Button, message, Modal, Upload } from "antd";
import { UploadOutlined, CheckOutlined, MailOutlined } from "@ant-design/icons";
import "./PaymentInfoPopup.css";
import logo from "../../assets/images/logo.png"
import { message as AntMessage } from "antd"
import { submitProof } from "services/authservice";
import PaypalPayment from "./PaypalPayment";
import Toast from "./Toast";

const PaymentInfoPopup = ({ open, onClose, email, phoneNumber, emailContact }) => {
    const [fileList, setFileList] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [toast, setToast] = useState({ type: "", message: "" });

    const showAnimatedToast = (type, message) => {
        setToast({ type, message });
        setTimeout(() => {
            setToast({ type: "", message: "" });
        }, 10000);
    };



    const validExts = ["jpeg", "jpg", "png", "pdf"];
    const validMimes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf"
    ];

    const beforeUpload = (file) => {
        const isValidMime = validMimes?.includes(file.type);

        const nameParts = file?.name?.split(".");
        const ext = nameParts?.length > 1
            ? nameParts[nameParts.length - 1].toLowerCase()
            : "";

        const isValidExt = validExts?.includes(ext);

        if (!isValidMime || !isValidExt) {
            message.error(
                "Seuls les fichiers JPEG, JPG, PNG et PDF sont autorisés."
            );
            return Upload?.LIST_IGNORE;
        }

        return false;
    };



    const handleUploadChange = ({ fileList }) => {
        setFileList(fileList);
    };

    const handleSubmit = async () => {
        if (fileList.length === 0 || !email) return;

        const file = fileList[0]?.originFileObj;
        const nameParts = file?.name?.split(".");
        const ext = nameParts?.length > 1
            ? nameParts[nameParts.length - 1]?.toLowerCase()
            : "";

        if (!validMimes?.includes(file.type) || !validExts?.includes(ext)) {
            message.error(
                "Type de fichier non autorisé. Seuls JPEG, JPG, PNG et PDF sont acceptés."
            );
            return;
        }

        setIsSubmitting(true);
        try {
            const formData = new FormData();
            formData.append("paymentImage", file);
            formData.append("email", email);

            const response = await submitProof(formData);
            if (response?.status) {
                message.success(response.message);
            } else {
                message.error(response.message);
            }

            setFileList([]);
            onClose();
        } catch (err) {
            AntMessage.error(err?.response?.data?.message || "Erreur lors de l'envoi.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // const [scriptLoaded, setScriptLoaded] = useState(false);

    // const handleClick = () => {
    //     if (scriptLoaded) return;

    //     const script = document.createElement('script');
    //     script.id = 'paypal-sdk';
    //     script.src = 'https://www.paypal.com/sdk/js?client-id=BAA4Mqt9okq3J1P67X_dnYS3VfBewebFRxwQZZK5kBZ_OFJ1XLqBZwvaV8oUsF-99Dtjoy0bxP5L2q5VPQ&components=hosted-buttons&disable-funding=venmo&currency=EUR';
    //     script.async = true;

    //     // Facultatif : callback après chargement
    //     script.onload = () => {
    //         console.log('PayPal SDK chargé');
    //         // ici, si vous aviez besoin d'initialiser le bouton hébergé :
    //         // window.paypal.HostedFields.render({...})
    //     };

    //     document.body.appendChild(script);
    //     setScriptLoaded(true);
    // };

    return (
        <div
            style={{
                width: "90%",
                margin: "0 auto",
                maxWidth: 800,
                backgroundColor: "transparent",
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // padding: "20px"
            }}
        >

            <Modal
                open={open}
                footer={null}
                onCancel={onClose}
                centered
                className="payment-popup"
                width={800}
            >
                <div className="popup-container">
                    <div className="popup-icon-left">
                        <span role="img">
                            <div className="text-primary text-center p-4">
                                <img src={logo} height="100" alt="logo" />
                            </div>
                        </span>
                    </div>

                    <div className="popup-content px-3 px-md-4">
                        <h2 className="popup-title mb-3">Offre Playmaker</h2>
                        <p className="popup-description">
                            Profitez d’un <strong>accès limité pendant 1 an</strong> pour seulement <strong>3 000 DA/an</strong>.
                        </p>
                        <p className="popup-phone mb-4">
                            <MailOutlined /> Contact :{" "}
                            <a href={`mailto:${emailContact}`} className="text-decoration-none">
                                {emailContact}
                            </a>
                        </p>

                        <div className="row justify-content-center gx-3 gy-3 mb-4">
                            <div className="col-12 col-md-6">
                                <div className="card shadow-sm h-100">
                                    <div className="card-body text-center p-2">
                                        <img
                                            src="/ribLogo.png"
                                            alt="Logo RIB"
                                            width="60"
                                            className="d-block mx-auto mb-2"
                                        />

                                        <h5 className="card-title fw-bold mb-2 text-dark fs-6">
                                            Eurl Mobile Apps Dz
                                        </h5>

                                        <ul className="list-unstyled mb-0">
                                            <li className="mb-1 text-center small">
                                                <span className="fw-semibold text-dark">Code banque :</span>
                                                <span className="fw-semibold ms-1 text-dark">005</span>
                                            </li>
                                            <li className="mb-1 text-center small">
                                                <span className="fw-semibold text-dark">N° :</span>
                                                <span className="fw-semibold ms-1 text-dark">001470000013311</span>
                                            </li>
                                            <li className="mb-1 text-center small">
                                                <span className="fw-semibold text-dark">Clé RIB :</span>
                                                <span className="fw-semibold ms-1 text-dark">53</span>
                                            </li>
                                            <li className="text-center small">
                                                <span className="fw-semibold text-dark">BIC :</span>
                                                <span className="fw-semibold ms-1 text-dark">BDLODZAL</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                {/* <div
                                    id="paypal-button-container"
                                    className="card shadow-sm h-100 paypal-hosted-button"
                                    style={{ cursor: 'pointer' }}
                                    data-paypal-button-id="VOTRE_ID_BOUTON"
                                    onClick={handleClick}
                                >
                                    <div className="card-body text-center p-2 d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                                        <img src="/paypalLogo.png" alt="Logo Paypal" width="80" className="d-block mx-auto mb-2" />
                                        <h5 className="card-title fw-bold mb-2 text-dark fs-6">Eurl Mobile Apps Dz</h5>
                                        <PaypalPayment />
                                    </div>
                                </div> */}
                                <PaypalPayment showAnimatedToast={showAnimatedToast} onClose={onClose} email={email} />


                            </div>
                        </div>

                        {/* ─── Section Upload ─── */}
                        <div className="upload-section">
                            <p className="mb-2">
                                Veuillez fournir un justificatif de paiement (par exemple : une image du virement bancaire ou du chèque).
                            </p>

                            <Upload
                                name="receipt"
                                listType="picture-card"
                                maxCount={1}
                                beforeUpload={beforeUpload}
                                fileList={fileList}
                                onChange={handleUploadChange}
                                className="custom-upload mb-3"
                            >
                                {fileList.length < 1 && (
                                    <div className="upload-btn text-center">
                                        <UploadOutlined style={{ fontSize: 24, color: "#4A90E2" }} />
                                        <div style={{ marginTop: 6, fontWeight: 500, fontSize: 12 }}>
                                            Télécharger un justificatif
                                        </div>
                                    </div>
                                )}
                            </Upload>

                            <Button
                                type="primary"
                                icon={<CheckOutlined />}
                                disabled={fileList.length === 0 || isSubmitting}
                                loading={isSubmitting}
                                onClick={handleSubmit}
                                className="mt-2"
                                style={{ fontWeight: "bold" }}
                            >
                                Envoyer le justificatif
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Toast type={toast?.type} message={toast?.message} />

        </div>

    );
};

export default PaymentInfoPopup;
